import styled, { css } from 'styled-components';

export const Nav = styled.nav<{ $isShrunk: boolean; $textColorOption: string }>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 15px;

  ${({
    $isShrunk,
    $textColorOption,
    theme: {
      colors,
      components: { header, navigation },
      fontFamilies,
      fontSizes,
      media,
    },
  }) => css`
    height: ${navigation.height};
    margin-left: ${navigation.marginLeft};

    ${media.md.down} {
      margin-left: 0;
      grid-column: 1 / span 3;
      display: none;
    }

    ul {
      display: flex;
      align-items: center;
      gap: ${navigation.list.gap};
      overflow-x: auto;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      @media (max-width: ${header.breakpoint}) {
        padding-right: ${navigation.list.paddingRight};
      }
    }

    a {
      font-family: ${fontFamilies.italianPlate};
      font-size: ${fontSizes.p1};
      text-decoration: none;
      transition: color 0.2s;
      text-transform: uppercase;
      white-space: nowrap;

      &:hover {
        color: ${colors.primaryBlue};
      }

      &:active {
        color: ${colors.primary};
      }

      &:focus-visible {
        outline: 2px solid ${colors.primaryBlue};
        outline-offset: 2px;
        border-radius: 2px;
      }

      &:focus:not(:focus-visible) {
        outline: none;
      }

      ${$isShrunk || $textColorOption === 'dark'
        ? css`
            color: ${colors.black};
          `
        : css`
            color: ${colors.white};
          `}
    }
  `}
`;

export const Item = styled.div<{ $isActive: boolean }>`
  ${({ theme: { colors } }) => css`
    &:hover {
      border-bottom: 1px solid ${colors.primary};
    }

    &:active {
      border-bottom: 0;
    }
  `}

  ${({ $isActive, theme: { colors } }) =>
    $isActive &&
    css`
      a {
        color: ${colors.primary};
      }
    `}
`;
